import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Loader2 } from 'lucide-react';
import { useCategorias, useCidadesMarketplace, useDiretorio } from '@/hooks/useMarketplace';
import { EmpresaCard } from './EmpresaCard';

/** Diretório de empresas: filtros (categoria + cidade) + grelha de cartões.
 *  Partilhado pela rota pública /empresas e pela home do cliente /app. */
export function DiretorioEmpresas() {
  const { t } = useTranslation();
  const [categoriaSlug, setCategoria] = useState<string | null>(null);
  const [cidadeNorm, setCidade] = useState<string | null>(null);

  const categorias = useCategorias();
  const cidades = useCidadesMarketplace();
  const empresas = useDiretorio({ categoriaSlug, cidadeNorm });

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-wrap gap-2">
        <select
          className="h-10 rounded-md border border-border bg-background px-3 text-sm"
          value={categoriaSlug ?? ''}
          onChange={(e) => setCategoria(e.target.value || null)}
          aria-label={t('marketplace.filters.allCategories')}
        >
          <option value="">{t('marketplace.filters.allCategories')}</option>
          {(categorias.data ?? []).map((c) => (
            <option key={c.slug} value={c.slug}>{c.nome}</option>
          ))}
        </select>
        <select
          className="h-10 rounded-md border border-border bg-background px-3 text-sm"
          value={cidadeNorm ?? ''}
          onChange={(e) => setCidade(e.target.value || null)}
          aria-label={t('marketplace.filters.allCities')}
        >
          <option value="">{t('marketplace.filters.allCities')}</option>
          {(cidades.data ?? []).map((c) => (
            <option key={c.cidade_norm} value={c.cidade_norm}>{c.cidade}</option>
          ))}
        </select>
      </div>

      {empresas.isLoading ? (
        <div className="flex justify-center py-16">
          <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
        </div>
      ) : (empresas.data ?? []).length === 0 ? (
        <div className="text-center text-sm text-muted-foreground py-16">
          {t('marketplace.empty')}
        </div>
      ) : (
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {(empresas.data ?? []).map((e) => (
            <EmpresaCard key={e.id} empresa={e} />
          ))}
        </div>
      )}
    </div>
  );
}
